import { List } from '@factorialco/deprecated-design-system'
import { ProjectManagementProjectRoleRoleEnum } from 'generated/resources/graphql'

import { EmployeeForSelectFragmentNoAccess } from 'modules/core/components/EntitySelectWrapper/Entities/Employees/types'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import CreateProjectRolePopover from './CreateProjectRolePopover'
import CreateProjectRoleRow from './CreateProjectRoleRow'

export interface projectRoleInterface {
  role: ProjectManagementProjectRoleRoleEnum
  employee: EmployeeForSelectFragmentNoAccess
}

export interface CreateProjectRolesSelectorProps {
  projectRoles: projectRoleInterface[]
  onUpdateRow: (
    employee: EmployeeForSelectFragmentNoAccess,
    role: ProjectManagementProjectRoleRoleEnum
  ) => void
  onDeleteRow: (employee: EmployeeForSelectFragmentNoAccess) => void
  isProjectOwner?: boolean
  setSelectedEmployees: (value: EmployeeForSelectFragmentNoAccess[]) => void
  excludeEmployeeIds: number[]
  selectedEmployees: EmployeeForSelectFragmentNoAccess[]
  onSelectEmployees: (employees: EmployeeForSelectFragmentNoAccess[]) => void
}

export const CreateProjectRolesSelector = ({
  projectRoles,
  onUpdateRow,
  onDeleteRow,
  isProjectOwner = true,
  setSelectedEmployees,
  excludeEmployeeIds,
  selectedEmployees,
  onSelectEmployees,
}: CreateProjectRolesSelectorProps) => {
  const { employee } = useCurrentSession()
  const currentEmployeeId = employee?.id

  const isThatYou = (employeeId: number) => {
    return employeeId === currentEmployeeId
  }

  const onSubmit = () => {
    const newSelectedEmployees = selectedEmployees.filter((e) => {
      return !projectRoles.map((pr) => pr.employee.id).includes(e.id)
    })

    newSelectedEmployees.forEach((e) => {
      onUpdateRow(e, 'editor')
    })

    setSelectedEmployees([])
  }

  return (
    <>
      {projectRoles.length !== 0 && (
        <List>
          {projectRoles.map((role, index) => (
            <CreateProjectRoleRow
              key={index}
              editable={!isThatYou(role.employee.id) && isProjectOwner}
              deletable={!isThatYou(role.employee.id)}
              role={role.role}
              employee={role.employee}
              employeeName={
                role.employee.fullName +
                (isThatYou(role.employee.id) ? ` (${i18n.t('common.you')})` : '')
              }
              onUpdateRow={onUpdateRow}
              onDeleteRow={onDeleteRow}
            />
          ))}
        </List>
      )}
      <CreateProjectRolePopover
        onSubmit={onSubmit}
        disabledSubmitButton={!selectedEmployees.length}
        excludeEmployeeIds={excludeEmployeeIds}
        selectedEmployees={selectedEmployees}
        onSelectEmployees={onSelectEmployees}
      />
    </>
  )
}
